import { Component, Inject, Input, OnInit } from "@angular/core";
import { ICustomViewComponent } from "@tylertech/custom-view";
import { ODataFilterFactoryService } from "@tylertech/odata-module";
import { IFundTotal, IInfoCardData } from "@tylertech/tyler-api-types";

import { FundTotalService } from "../services/fundTotalService.g";

@Component({
    selector: "fund-total-detail",
    templateUrl: "./fundTotalDetail.tmpl.html",
    standalone: false
})
export class FundTotalDetailComponent implements OnInit, ICustomViewComponent<IInfoCardData>
{
    private _id: string;
    private _cardProviderId: string;
    readonly customDataBinding: IInfoCardData;

    @Input()
    get cardProviderId(): string { return this.customDataBinding?.CardProviderId || this._cardProviderId; }

    set cardProviderId(value: string) { this._cardProviderId = value; }

    @Input()
    get id(): string { return this.customDataBinding?.Id || this._id; }

    set id(value: string) { this._id = value; }

    funds: ReadonlyArray<IFundTotal>;
    isLoaded: boolean;

    constructor(
        private readonly $odataFilterFactory: ODataFilterFactoryService,
        private readonly $fundTotalService: FundTotalService
    ) { }


    ngOnInit(): void
    {
        const builder = this.$odataFilterFactory.createBuilder()
            .filterEQ("providerId", this.cardProviderId)
            .filterEQ("id", this.id);
        this.$fundTotalService
            .GetFundAmountChartInfo(null, builder.build())
            .then((result: ReadonlyArray<IFundTotal>) =>
            {
                if (result)
                {
                    this.funds = result;
                }
            })
            .finally(() =>
            {
                this.isLoaded = !!this.funds;
            });
    }
}
